export const NOW = new Date();

export const DAY_STRING_FORMAT = "MMM dd, yyyy";
export const DAY_TIME_STRING_FORMAT = "MMM dd, yyyy hh:mm a";
export const MONTH_STRING_FORMAT = "MMM, yyyy";
export const YEAR_STRING_FORMAT = "yyyy";

export const VARIANT_FORMAT_MAPPING = {
  day: DAY_STRING_FORMAT,
  week: DAY_STRING_FORMAT,
  month: MONTH_STRING_FORMAT,
  year: YEAR_STRING_FORMAT,
  time: DAY_TIME_STRING_FORMAT,
};
